// Google Auth Callback - Processes OAuth redirect
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUserAuth } from '@/context/UserAuthContext';
import { Loader2 } from 'lucide-react';

export default function GoogleAuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { exchangeSession } = useUserAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef for the processed flag to prevent race conditions under StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment (hash)
      const hash = location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        console.error('No session_id found in URL');
        navigate('/login', { replace: true });
        return;
      }

      // Exchange session_id for user data
      const result = await exchangeSession(sessionId);

      // Clear the URL hash
      window.history.replaceState(null, '', window.location.pathname);

      if (result.success) {
        // Redirect to account page or home with user data
        navigate('/', { 
          replace: true,
          state: { user: result.user }
        });
      } else {
        console.error('Auth failed:', result.error);
        navigate('/login', { 
          replace: true,
          state: { error: result.error }
        });
      }
    };

    processAuth();
  }, [location.hash, exchangeSession, navigate]);

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin text-blue-500 mx-auto mb-4" />
        <p className="text-slate-300 text-lg">Signing you in...</p>
      </div>
    </div>
  );
}
